import Image from "next/image";
import React from "react";
import P from "~ui/typography/p";
import H4 from "~ui/typography/h4";
import ConnectWalletButton from "~components/web3/connect-wallet-button";

const LoginRequired = ({ subtitle = "Login to see this page." }) => {
  return (
    <div className="flex flex-col justify-center items-center mt-[40px]">
      <div className="relative ">
        <Image
          alt="You're not logged in"
          src="/assets/images/not-connected-door.png"
          width={120}
          height={120}
          quality={100}
          objectFit="cover"
        />
      </div>

      <H4 className="@ftf font-clash @ftw font-semibold @leh leading-[22px] @fts text-[20px] text-zinc-base mt-5">
        You're not logged in
      </H4>
      <P className="@ftf font-montserrat @ftw font-medium @leh leading-[20px] @fts text-[14px] text-zinc-base mt-3">
        {subtitle}
      </P>

      <div className="w-full max-w-[178px] mt-5 mb-20">
        <ConnectWalletButton />
      </div>
    </div>
  );
};

export default LoginRequired;
